
@if (filter || parallel || reward || sequential || counter || delay) {
  <div class="multi-strategy-edit"
    [class.state-none]="strategy?.state == 0"
    [class.state-started]="strategy?.state == 1"
    [class.state-finished]="strategy?.state == 2">
    @if (filter) {
      <app-filter-strategy-edit [strategy]="filter" class="strategy"></app-filter-strategy-edit>
    }
    @if (parallel) {
      <app-parallel-strategy-edit [strategy]="parallel" class="strategy"></app-parallel-strategy-edit>
    }
    @if (reward) {
      <app-reward-strategy-edit [strategy]="reward" class="strategy"></app-reward-strategy-edit>
    }
    @if (sequential) {
      <app-sequential-strategy-edit [strategy]="sequential" class="strategy"></app-sequential-strategy-edit>
    }
    @if (counter) {
      <app-counter-strategy-edit [strategy]="counter" class="strategy"></app-counter-strategy-edit>
    }
    @if (delay) {
      <app-delay-strategy-edit [strategy]="delay" class="strategy"></app-delay-strategy-edit>
    }
  </div>
}



